require('./css/jppolstyles.scss');
require("expose-loader?VideoPlayer!./VideoPlayer/VideoPlayer");




// WEBPACK FOOTER //
// ./index.ts